import Route from '@ember/routing/route';
import { trackPageViewFromTransition } from 'sh-www/utils/datalayer';

class SettingsResetEmailRoute extends Route {
  activate(transition) {
    super.activate(...arguments);
    this.controllerFor('settings').set('newSettingsPage', true);
    trackPageViewFromTransition(this, transition, '/settings/reset-email/');
  }

  /** @inheritDoc */
  deactivate() {
    super.deactivate(...arguments);
    this.controllerFor('settings').set('newSettingsPage', false);
  }
}

export default SettingsResetEmailRoute;
